import {captureException} from '@sentry/react';
import {match} from 'ts-pattern';

import {isError} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

const APPLICATION_INITIALIZE_EVENT_NAME = 'applicationInitializeBoundary';
const GTM_ERROR_FINGERPRINT = 'gtm-application-initialize-boundary';

export type ApplicationInitializeEventData = {
  workspace: string | Nullish;
  environment: string | Nullish;
  offerId: string | Nullish;
};

export function pushApplicationInitializeEvent(eventData: ApplicationInitializeEventData) {
  const event = {
    event: APPLICATION_INITIALIZE_EVENT_NAME,
    ...eventData,
  };

  try {
    window.dataLayer?.push(event);
  } catch (error) {
    const normalizedError = match(error)
      .when(isError, (caughtError) => caughtError)
      .otherwise((caughtValue) => new Error(String(caughtValue)));

    captureException(normalizedError, {
      fingerprint: [GTM_ERROR_FINGERPRINT],
      tags: {
        integration: 'gtm',
        gtm_event: APPLICATION_INITIALIZE_EVENT_NAME,
      },
    });
  }
}
